import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from 'react-router-dom';
import AppLogo from "../common/AppLogo";
import { Link } from "react-router-dom";
import Logo from "../Header/Logo";
import './index.scss'
import FooterLogo from "./Logo";
import { baseUrl } from "../../environment";
import moment from 'moment-timezone';
import { logout } from "../../context/actions/user";
import { useIdleTimer } from 'react-idle-timer';
import Cookies from 'js-cookie';
const { DateTime } = require('luxon');

const today = new Date();
const Footer = ({ className }) => {
	const history = useHistory();
	const location = useLocation();

	const [previousComponentURL, setPreviousComponentURL] = useState(null);
	const dispatch = useDispatch();
	const [timezone, setTimezone] = useState('');
	const [time, setTime] = useState('');
	const [userTimezone, setUserTimezone] = useState('');
	const [userTime, setUserTime] = useState('');
	// const [systemTime, setSystemTime] = useState(false);
	const userDetail = useSelector((state) => state?.user?.user);
	let timeZone = DateTime.local().zoneName;

	const getTimeZone = async () => {
		const currentTimeZone = DateTime.local().zoneName;
		const timeZoneDateTime = DateTime.now().setZone(currentTimeZone);
		setTime(moment.tz(timeZoneDateTime.ts, currentTimeZone).format('MM/DD/YYYY, h:mm A'));
		const timezoneAbbr = moment.tz(currentTimeZone).format('z');
		setTimezone(timezoneAbbr);
	}

	useEffect(() => {
		// console.log("timezone",userDetail)
		if (userDetail && (userDetail?.timezone && userDetail.isTimezoneSet === false)) {
			// console.log("inside if")
			// setSystemTime(true)
			userDetail['timezone'] = timeZone
			userDetail['isTimezoneSet'] = false
			dispatch({ type: "UPDATE_TIMEZONE", data: userDetail });
		} else if (userDetail && userDetail?.timezone && userDetail.isTimezoneSet) {
			// console.log("inside else")
			const intervalId = setInterval(() => {
				const timezoneAbbr = moment.tz(userDetail.timezone).format('z');
				// if(!systemTime){
				setUserTime(moment().tz(userDetail.timezone).format('MM/DD/YYYY, h:mm A'))
				setUserTimezone(timezoneAbbr);
				// }
			}, 1000)
			return () => {
				clearInterval(intervalId);
			}
		}

	}, [userTime, userTimezone, userDetail, timeZone, dispatch])

	useEffect(() => {
		const interval = setInterval(() => getTimeZone(), 1000);
		window.addEventListener('timezonechange', getTimeZone);
		return () => {
			window.removeEventListener('timezonechange', getTimeZone);
			clearInterval(interval);
		}
	}, [time, timezone]);

	// const IdleRefreshThreshold = 10 * 60 ; // 60 seconds of inactivity
	
	// Define the threshold for idle logout (15 minutes)
	const idleLogoutThreshold = 1000 * 60 * 15;

	// Function to handle user being idle
	const handleOnIdle = event => {
		console.log('user is idle', event);
		console.log('last active', getLastActiveTime());
		// Dispatch logout action when user is idle
		dispatch(logout(() => {
		}));
	};

	// Initialize the idle timer with the specified timeout and idle handler
	const { getRemainingTime, getLastActiveTime } = useIdleTimer({
		timeout: idleLogoutThreshold,
		// timeout: 1000 * 60 * 2,
        // onIdle: handleOnIdle,
		// onIdle: handleOnIdle, // Uncomment to enable auto-logout on idle
	});

	// Effect to manage 'lastActive' cookie based on user's navigation
	useEffect(() => {
		const lastActive = Cookies.get('lastActive');

		// Set 'lastActive' cookie when user is on the dashboard
		if (!lastActive && history.location.pathname === '/dashboard') {
			Cookies.set('lastActive', Date.now());
		}

		// Remove 'lastActive' cookie when user navigates away from the dashboard
		if (history.location.pathname !== '/dashboard') {
			Cookies.remove('lastActive')
		}

	}, [time]);

	// Effect to check if user should be logged out due to inactivity
	useEffect(() => {
		// const lastActive = localStorage.getItem('lastActive');
		const lastActive = Cookies.get('lastActive');
		// console.log(lastActive && Date.now() - lastActive ,">", idleLogoutThreshold, "&&", history.location.pathname === '/dashboard' ); 
		// Check if the user has been inactive for longer than the threshold
		if (lastActive && Date.now() - lastActive > idleLogoutThreshold) {
			if (history.location.pathname === '/dashboard')
				handleOnIdle();
		}

	}, [time]);
	// useEffect(() => {
	// 	const trustLogo = () => {
	//         window.TrustLogo(
	//             "https://ssl.comodoca.com/images/seals/sectigo_trust_seal_sm_2x.png",
	//             "SECDV",
	//             "none"
	//         );
	//     };

	//     trustLogo();

	//     const anchor = document.getElementsByTagName('a');
	//     if (anchor.length > 0) {
	//         let href = anchor[anchor.length - 1].href
	//         if (href.includes('javascript:if(window.open'))
	// 			setSectHref(href)
	//             anchor[anchor.length - 1].innerHTML=""
	//     }
	// }, [])
	return <>
		<div className={`footer ${className}`}>
			<div className="info d-flex justify-content-around">
				{(userTimezone && userTime) &&
					(<div className="d-flex">
						<div className="ttl">
							{`User Timezone: ${userTimezone}`}
						</div>
						<div className="mx-2">|</div>
						<div className='text'>
							{`User Time: ${userTime}`}
						</div>
					</div>)
				}
				{(timezone && time) && (<div className="d-flex">
					<div className="ttl">
						{`Current Timezone: ${timezone}`}
					</div>
					<div className="mx-2">|</div>
					<div className='text'>
						{`Current Time: ${time}`}
					</div>
				</div>)}
			</div>
			<div className="footer-rw">
				<p className="txt-1 d-flex flex-wrap align-items-center justify-content-center">
					<FooterLogo />
					&copy; {today.getFullYear()} TRAiNED. All rights reserved.
					<span>|</span>
					<a href="/terms-and-condition/cookie-notice" target="_blank">Terms & Conditions</a>
					{/* <a href={sectHref} className="d-inline-flex cerficate-logo" onmouseover="tLeB(event,'http://www.trustlogo.com/ttb_searcher/trustlogo?v_querytype=C&amp;v_shortname=SECDV&amp;v_search=http://localhost:3000/dashboard&amp;x=6&amp;y=5','tl_popupSECDV')" onmousemove="tLXB(event)" onmouseout="tLTC('tl_popupSECDV')" ondragstart="return false;">
					<img src="https://ssl.comodoca.com/images/seals/sectigo_trust_seal_sm_2x.png" className="img-fluid" alt="SECDV" title="SECDV" />
					</a> */}
					<a className="d-inline-flex cerficate-logo" href={`javascript:if(window.open('http://www.trustlogo.com/ttb_searcher/trustlogo?v_querytype=W&v_shortname=SECDV&v_search=${baseUrl}/&x=6&y=5','tl_wnd_credentials'+(new Date()).getTime(),'toolbar=0,scrollbars=1,location=1,status=1,menubar=1,resizable=1,width=374,height=660,left=60,top=120')){};tLlB(tLTB);`} onmouseover={`tLeB(event,'http://www.trustlogo.com/ttb_searcher/trustlogo?v_querytype=C&v_shortname=SECDV&v_search=${baseUrl}/&x=6&y=5','tl_popupSECDV')`} onmousemove="tLXB(event)" onmouseout="tLTC('tl_popupSECDV')" ondragstart="return false;">
						<img src="https://ssl.comodoca.com/images/seals/sectigo_trust_seal_sm_2x.png" className="img-fluid" alt="SECDV" title="SECDV" />
					</a>

				</p>
			</div>
			<div className="copyright text-center">
				<p>
					All copyrights, trademarks, trade names, logos, and service marks (the "Marks") displayed on this website are the property of TRAiNED or the property of respective third parties.
				</p>
			</div>
		</div>

	</>
};

export default Footer;